import { Box, ColumnsV2, Flex, StyleSystemProps, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { HighlightProps } from './Highlight';
import { ResponsiveBackgroundImageProps } from '@withjoy/joykit/styled-system';
import { CSSObject } from '@withjoy/joykit/components/Box/Box.types';

export const HighlightColumn = styled(ColumnsV2.Column)``;

const variantContentStyles: CSSObject = {
  height: [pxToRem(390), pxToRem(390), pxToRem(376)],
  padding: [0, 0, 7],
  borderRadius: [0, 0, pxToRem(12)],
  paddingLeft: [null, null, 7, pxToRem(80)],
  textAlign: ['center', 'left'],
  alignItems: ['center', 'flex-start'],
  ['& iframe']: {
    height: [pxToRem(390), pxToRem(390), '100%'],
    width: [pxToRem(390), pxToRem(390), '100%']
  }
};

export const HighlightColumnContent = styled(Flex)``;
const highlightColumnContentStyles = ({ type, variant, colorMode }: Pick<HighlightProps, 'type' | 'variant' | 'colorMode'>): StyleSystemProps => ({
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  height: type === 'primary' ? [pxToRem(528), pxToRem(528), pxToRem(376)] : pxToRem(300),
  width: '100%',
  borderRadius: pxToRem(12),
  overflow: 'hidden',
  flexDirection: 'column',
  alignItems: ['center', 'center', 'flex-start'],
  textAlign: ['center', 'center', 'left'],
  padding: type === 'primary' ? 7 : [6, 6, 7],
  color: colorMode === 'light' ? 'white' : null,
  position: 'relative',
  ...(type === 'primary' && {
    alignItems: 'center',
    justifyContent: [null, null, 'center'],
    textAlign: 'center',
    paddingRight:
      variant === 'weddingTrack'
        ? {
            sm2: pxToRem(304),
            md3: pxToRem(315)
          }
        : [null, null, pxToRem(315), pxToRem(448)]
  }),
  ...(type === 'primary' &&
    variant === 'babyOverview' && {
      ...variantContentStyles
    })
});

export const HighlightAnimationContainer = styled(Box)``;
const highlightAnimationContainerStyles = ({ backgroundImage, variant }: ResponsiveBackgroundImageProps & Pick<HighlightProps, 'variant'>): StyleSystemProps => ({
  backgroundColor: 'white',
  backgroundImage,
  backgroundSize: ['cover', 'cover', 'contain'],
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  position: 'absolute',
  top: 0,
  left:
    variant === 'weddingTrack'
      ? {
          _: '50%',
          md: '35%',
          md3: '40%'
        }
      : '50%',
  transform: 'translate(-50%, 0)',
  width: ['100%', '100%', pxToRem(variant === 'babyOverview' ? 1200 : 1104)],
  height: ['100%', '100%', pxToRem(376)]
});

export const styles = {
  highlightColumnContent: highlightColumnContentStyles,
  highlightAnimationContainer: highlightAnimationContainerStyles
};
